<template>
  <el-card shadow="never" class="silimar-card">
    <h4>近30天同类活动对比</h4>
    <el-table
      v-if="tableData && tableData.length"
      :data="tableData"
      height="380"
      stripe
      style="width: 100%">
      <template v-for="item in column">
        <el-table-column v-if="item.slot" :key="item.prop" :prop="item.prop" :width="item.width" :label="item.label" :fixed="item.fixed" align="center">
          <template slot-scope="{row}">
            <span style="color:#3377FF;cursor: pointer" @click="openDetail(row.activeId)">{{row.activityName}}</span>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.unit" :key="item.prop" :prop="item.prop" :width="item.width" :label="item.label" :fixed="item.fixed" align="center">
          <template slot-scope="{row}">
            <span>{{yuanUnit(row[item.prop])}}</span><span v-show="row[item.prop]!==null">{{item.unit}}</span>
          </template>
        </el-table-column>
        <el-table-column v-else :key="item.prop" :prop="item.prop" :width="item.width" :label="item.label" :fixed="item.fixed" align="center"></el-table-column>
      </template>
    </el-table>
    <NoData v-else errTitle="暂无数据" setHeight="400px"></NoData>
  </el-card>
</template>
<script>
import { column, yuanUnit } from '../config'
import { getSimilarActive } from "@/api/marketPromotion/activeData";
import NoData from "@/components/base/no-data"
export default {
  components: {NoData},
  props: {
    baseData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      column,
      tableData: []
    }
  },
  methods: {
    yuanUnit,
    init () {
      let params = Object.assign({}, this.baseData)
      delete params.dataType
      this.getSimilarActive(params)
    },
    openDetail (activeId) {
      this.$emit('openDetail',activeId)
    },
     async getSimilarActive (params) {
      const { code, result } = await getSimilarActive(params)
      if(code !== 200) return
      this.tableData = result
    }
  }
}
</script>
<style lang="less" scoped>
.silimar-card {
  width: 49%;
  margin-top: 8px;
  p {
    margin: 0;
  }
  h4 {
    margin: 0;
    margin-bottom: 16px;
  }
}
</style>